import { Button, Chip, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, FormControl, FormControlLabel, InputLabel, MenuItem, Select, styled, Switch, SwitchProps, TextField } from "@mui/material"
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Box from "elements/Box";
import { useSnackbar, withSnackbar } from "notistack";
import ISwitch from "elements/ISwitch";
import AutocompleteField from "elements/AutocompleteField";
import { ApiRequest } from "GlobalFunctions";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import AddIcon from '@mui/icons-material/Add';
import { IconButton } from "@mui/material";



export default function UsersEditor(props : any) {

  /*=============================================
  VARIABLES FROM PROPS
  ============================================= */
  const {
    setLoading, 
    openEditor, 
    setOpenEditor, 
    user_id,
    loadList,
    company_id = null,
  } = props;

  /*SNACKBAR FUNCTION FOR NOTIFICATIONS*/
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  /*============================================= */



  const defaultValues: any = {
    user_id: user_id? user_id : "null",
    name: "",
    last_name: "",
    phone: "",
    email: "",
    password: "",
    is_active: true,
    role_id: 2, 
    company_id: company_id,
    vehicle_id: null, // Añadido vehicle_id
    zones: [],
    restrictions: {},
    roles: [],
    warehouses: [], // Añadido warehouses array
  };

  console.log("company_id en editor", company_id);
  
  const [formValues, setFormValues] = useState(defaultValues)
  const [roles, setRoles] = useState([]);
  const [zones, setZones] = useState([]);
  const [emailCheckDialog, setEmailCheckDialog] = useState<{open: boolean, userName: string, companies: string[]}>({open: false, userName: '', companies: []});


  const warehouseDefault = {
    warehouse_id: null,
    priority: ""
  }

  useEffect(() => {
    if(openEditor && !user_id){
      setFormValues({
        ...defaultValues,
        warehouses: []
      });
    }
  }, [openEditor]);

  const addWarehouse = () => {
    const newWarehouses = [...(formValues.warehouses || [])]; // Handle case when warehouses is undefined
    newWarehouses.push(warehouseDefault);
    setFormValues({
      ...formValues,
      warehouses: newWarehouses
    });
    console.log("Added warehouse", newWarehouses);
  }

  /*=======================================
  ROLES
  =======================================*/
  useEffect(() => {
    if(openEditor){
      getRoles();
    }
  }
  , [openEditor]);

  const getRoles = async () => {
    await ApiRequest({
      url: "/roles/list",
      method: "get",
      headers: {
        ltkn: localStorage.getItem('ltkn'),
      },
      setResponse: (response: any) => {
        setRoles(response);
      },
    });
  }

  /*=======================================
  ZONES
  =======================================*/
  useEffect(() => {
    if(openEditor){
      getZones();
    }
  } , [openEditor]);

  const getZones = async () => {
    await ApiRequest({
      url: "/zones/list",
      method: "get",
      headers: {
        ltkn: localStorage.getItem('ltkn'),
      },
      query: {
        full_list: true,
      },
      setResponse: (response: any) => {
        console.log("zones", response);
        setZones(response.list);
      },
    });
  }


  /*=======================================
  GET USER DETAILS IF USER_ID EXISTS
  =======================================*/
  useEffect(() => {
    console.log("user_id in useEffect", user_id);
    if (user_id) {
      ApiRequest({
        url: "/users/details",
        method: "get",
        headers: {
          ltkn: localStorage.getItem('ltkn'),
        },
        query: {
          user_id: user_id,
        },
        setResponse: (response: any) => {
          console.log("RESPONSE USERS", response);
          setFormValues(response);
        },
      });
    }
    else{
      setFormValues(defaultValues);
    }
    
  } , [user_id])




  /*=======================================
  HANDLE INPUT CHANGE
  =======================================*/
  const handleInputChange = (e: { target: { name: any; value: any; }; }) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };


  /*=======================================
  SUBMIT FUNCTION
  =======================================*/
  const handleSubmit = async (skipCheck = false) => {
    // Validaciones
    if (formValues.restrictions?.limit_by_portfolio) {
      if (!formValues.restrictions?.portfolios || formValues.restrictions.portfolios.length === 0) {
        enqueueSnackbar('Debe seleccionar al menos un portfolio', { variant: 'error' });
        return;
      }
    }

    if (formValues.restrictions?.limit_by_supplier) {
      if (!formValues.restrictions?.suppliers || formValues.restrictions.suppliers.length === 0) {
        enqueueSnackbar('Debe seleccionar al menos un proveedor', { variant: 'error' });
        return;
      }
    }

    // Verificar email si es usuario nuevo y no se ha confirmado
    if (!skipCheck && (!user_id || formValues.user_id === "null") && formValues.email) {
      const emailExists = await checkEmailExists(formValues.email);
      if (emailExists) return; // El diálogo se muestra, esperar confirmación
    }

    setLoading(true);

    const body = new FormData();
    body.append("formValues", JSON.stringify(formValues));
    console.log("formValues", formValues);


    console.log("company_id antes de enviar", company_id);

    await ApiRequest({
      url: "/users/addedit",
      method: "post",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
      },
      body: body,
      setResponse: (response: any) => {
        if (response.status === "success") {
          enqueueSnackbar('Usuario guardado con éxito', { variant: 'success' });
          setOpenEditor(false);
          loadList();
        } else {
          enqueueSnackbar(response.message, { variant: "error" });
        }
        setLoading(false);
      },
    });
  };

  const checkEmailExists = async (email: string): Promise<boolean> => {
    let found = false;
    await ApiRequest({
      url: "/users/checkEmail",
      method: "get",
      headers: { ltkn: localStorage.getItem("ltkn") },
      query: { email },
      setResponse: (response: any) => {
        if (response.exists && !response.already_in_company) {
          setEmailCheckDialog({ open: true, userName: response.user_name, companies: response.companies });
          found = true;
        } else if (response.exists && response.already_in_company) {
          enqueueSnackbar('Este usuario ya está asignado a esta empresa', { variant: 'error' });
          found = true;
        }
      },
    });
    return found;
  };






  return (
      <>
        <Dialog
          open={openEditor}
          onClose={() => setOpenEditor(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          maxWidth="md"
          fullWidth
        >
          <div className="DialogContainer">
              <div className="ModuleWrapper">
                  <div className="boxContainerHeader">
                      <div className="boxContainerTitle">
                          <h2 className="h2_title">Usuario</h2>
                          <span className="h2_subtitle">Editar</span>
                      </div>

                      
                  </div>

                  <div id="userForm">
                    <div className="userForm_right">
                      
                        <div className='input_group'>
                            <h2>Información Personal</h2>
                            <div className='input_group'>
                                <div className='input_row'>
                                <TextField 
                                  id="name"
                                  name="name"
                                  label="Nombres"
                                  type="text"
                                  required
                                  fullWidth
                                  value={formValues.name}
                                  onChange={handleInputChange}
                                />

                                <TextField
                                  id="last_name"
                                  name="last_name"
                                  label="Apellidos"
                                  type="text"
                                  required
                                  fullWidth
                                  value={formValues.last_name}
                                  onChange={handleInputChange}
                                />
                              </div>

                              <TextField
                                id="phone"
                                name="phone"
                                label="Teléfono"
                                type="text"
                                required
                                fullWidth
                                value={formValues.phone}
                                onChange={handleInputChange}
                              />

                              

                            </div>

                            <div className='input_group'>
                              <h2>Información de sesión</h2>
                              <div className="input_row">
                                <TextField
                                  id="email"
                                  name="email"
                                  label="Email"
                                  type="text"
                                  required
                                  fullWidth
                                  value={formValues.email}
                                  onChange={handleInputChange}
                                />

                                <TextField
                                  id="password"
                                  name="password"
                                  label="Password"
                                  type="password"
                                  autoComplete="new-password"
                                  required
                                  fullWidth
                                  value={formValues.password}
                                  onChange={handleInputChange}
                                />
                              </div>



                            <AutocompleteField
                              label="Zonas"
                              endpoint="/zones/list"
                              value={formValues.zones}
                              onChange={(data: any) => {
                                console.log("data", data);
                                  setFormValues({...formValues, zones: data ? data : []});
                              }}
                              multiple={true}
                            />

                            <AutocompleteField
                                label="Vehículo"
                                endpoint="/vehicles/list"
                                value={formValues.vehicle_id}
                                onChange={(data: any) => {
                                  setFormValues({
                                    ...formValues,
                                    vehicle_id: data?.vehicle_id || null
                                  });
                                }}
                                renderValues={["license_plate", "vehicle_name"]}
                              />
                              
                            </div>

                            <div className='input_group'>
                              <h2>Permisos</h2>
                              <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Rol</InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  value={formValues.roles}
                                  label="Reporte"
                                  name="roles"
                                  multiple
                                  onChange={(e: any) => {
                                    setFormValues({
                                      ...formValues,
                                      ["roles"]: e.target.value
                                    });
                                    console.log("roles", e.target.value);
                                  }}
                                >
                                  {roles.map((role: any, index: number) => {
                                    return <MenuItem key={index} value={role.role_id}>
                                      <div className="flex_menuitem">
                                        <span className="menuitem_name">{role.role} 
                                          {role.login_web ? <Chip label="Web" size="small" color="primary" /> : null}
                                          {role.login_app ? <Chip label="App" size="small" color="secondary" /> : null}
                                          
                                          </span>
                                        <span className="menuitem_categories">{role.categories}</span>
                                      </div>
                                    </MenuItem>
                                  })}
                                  
                                </Select>
                              </FormControl>
                            </div>

                            <div className='input_group'>
                            <h2>Bodegas</h2>
                            <div className="warehouseList input_group">
                              {formValues.warehouses?.map((warehouse: any, index: number) => (
                                <div key={index} className="warehouseListItem input_row"> 
                                    <AutocompleteField
                                      label="Bodega"
                                      endpoint="/warehouses/list"
                                      fullwidth
                                      value={warehouse.warehouse_id}
                                      onChange={(data: any) => {
                                        let newWarehouses = [...formValues.warehouses];
                                        newWarehouses[index] = {
                                          ...newWarehouses[index],
                                          warehouse_id: data.value,
                                        };
                                        setFormValues({ ...formValues, warehouses: newWarehouses });
                                      }}
                                    />
                                  <TextField
                                    label="Prioridad"
                                    type="number"
                                    value={warehouse.priority}
                                    onChange={(e) => {
                                      let newWarehouses = [...formValues.warehouses];
                                      newWarehouses[index] = {
                                        ...newWarehouses[index],
                                        priority: e.target.value,
                                      };
                                      setFormValues({ ...formValues, warehouses: newWarehouses });
                                    }}
                                  />
                                  <DeleteOutlineOutlinedIcon 
                                    onClick={() => {
                                      let newWarehouses = [...formValues.warehouses];
                                      newWarehouses.splice(index, 1);
                                      setFormValues({ ...formValues, warehouses: newWarehouses });
                                    }}
                                  />
                                </div>
                              ))}
                              <div className="addWarehouseButton">
                                <IconButton 
                                  aria-label="add" 
                                  onClick={addWarehouse} 
                                  sx={{ 
                                    backgroundColor: "#1C3B41", 
                                    padding: '10px', 
                                    color: '#fff', 
                                    '&:hover': { backgroundColor: '#24545d' } 
                                  }}
                                >
                                  <AddIcon />
                                </IconButton>
                              </div>
                            </div>
                          </div>


                            

                            <div className='input_group'>
                              <h2>Restricciones</h2>
                              <div className="input_row flex_wrap">
                                {/* restrictions.price */}
                                <ISwitch
                                  label="Precio"
                                  checked={formValues.restrictions?.price !== undefined ? formValues.restrictions.price : false}
                                  onChange={(e: any) => {
                                    setFormValues({
                                      ...formValues,
                                      restrictions: {
                                        ...formValues.restrictions,
                                        price: e.target.checked,
                                      },
                                    });
                                  }}
                                />

                                {/* restrictions.stock */}
                                <ISwitch
                                  label="Cantidades"
                                  checked={formValues.restrictions?.stock !== undefined ? formValues.restrictions.stock : false}
                                  onChange={(e: any) => {
                                    setFormValues({
                                      ...formValues,
                                      restrictions: {
                                        ...formValues.restrictions,
                                        stock: e.target.checked,
                                      },
                                    });
                                  }}
                                />

                                {/* restrictions.category */}
                                <ISwitch
                                  label="Categoría"
                                  checked={formValues.restrictions?.category !== undefined ? formValues.restrictions.category : false}
                                  onChange={(e: any) => {
                                    setFormValues({
                                      ...formValues,
                                      restrictions: {
                                        ...formValues.restrictions,
                                        category: e.target.checked,
                                      },
                                    });
                                  }}
                                />

                                {/* restrictions.group */}
                                <ISwitch
                                  label="Grupo"
                                  checked={formValues.restrictions?.group !== undefined ? formValues.restrictions.group : false}
                                  onChange={(e: any) => {
                                    setFormValues({
                                      ...formValues,
                                      restrictions: {
                                        ...formValues.restrictions,
                                        group: e.target.checked,
                                      },
                                    });
                                  }}

                                />

                                {/* restrictions.brand */}
                                <ISwitch
                                  label="Marca"
                                  checked={formValues.restrictions?.brand !== undefined ? formValues.restrictions.brand : false}
                                  onChange={(e: any) => {
                                    setFormValues({
                                      ...formValues,
                                      restrictions: {
                                        ...formValues.restrictions,
                                        brand: e.target.checked,
                                      },
                                    });
                                  }}
                                />

                              </div>
                            </div>

                            <div className='input_group'>
                              <h2>Limitaciones de Productos</h2>
                              <div className="input_row" style={{ display: 'flex', gap: '20px' }}>
                                <ISwitch
                                  label="Limitar con Portafolios"
                                  checked={formValues.restrictions?.limit_by_portfolio !== undefined ? formValues.restrictions.limit_by_portfolio : false}
                                  onChange={(e: any) => {
                                    const isChecked = e.target.checked;
                                    setFormValues({
                                      ...formValues,
                                      restrictions: {
                                        ...formValues.restrictions,
                                        limit_by_portfolio: isChecked,
                                        limit_by_supplier: isChecked ? false : formValues.restrictions?.limit_by_supplier,
                                        suppliers: isChecked ? [] : formValues.restrictions?.suppliers
                                      },
                                    });
                                  }}
                                />

                                <ISwitch
                                  label="Limitar con Proveedores"
                                  checked={formValues.restrictions?.limit_by_supplier !== undefined ? formValues.restrictions.limit_by_supplier : false}
                                  onChange={(e: any) => {
                                    const isChecked = e.target.checked;
                                    setFormValues({
                                      ...formValues,
                                      restrictions: {
                                        ...formValues.restrictions,
                                        limit_by_supplier: isChecked,
                                        limit_by_portfolio: isChecked ? false : formValues.restrictions?.limit_by_portfolio,
                                        portfolios: isChecked ? [] : formValues.restrictions?.portfolios
                                      },
                                    });
                                  }}
                                />
                              </div>
                            </div>

                            {formValues.restrictions?.limit_by_portfolio && (
                              <div className='input_group'>
                                <h2>Portfolios</h2>
                                <AutocompleteField
                                  label="Portfolios"
                                  endpoint="/portfolios/list"
                                  value={formValues.restrictions?.portfolios || []}
                                  onChange={(portfolioIds: any) => {
                                    console.log("portfolios IDs", portfolioIds);
                                    setFormValues({
                                      ...formValues,
                                      restrictions: {
                                        ...formValues.restrictions,
                                        portfolios: portfolioIds || []
                                      }
                                    });
                                  }}
                                  multiple={true}
                                />
                              </div>
                            )}

                            {formValues.restrictions?.limit_by_supplier && (
                              <div className='input_group'>
                                <h2>Proveedores</h2>
                                <AutocompleteField
                                  label="Proveedores"
                                  endpoint="/suppliers/list"
                                  value={formValues.restrictions?.suppliers || []}
                                  onChange={(supplierIds: any) => {
                                    console.log("suppliers IDs", supplierIds);
                                    setFormValues({
                                      ...formValues,
                                      restrictions: {
                                        ...formValues.restrictions,
                                        suppliers: supplierIds || []
                                      }
                                    });
                                  }}
                                  multiple={true}
                                />
                              </div>
                            )}

                            <div className='input_group'>
                              <h2>Catálogos</h2>
                              <ISwitch
                                label="Asignar Catálogos"
                                checked={formValues.restrictions?.limit_by_catalog !== undefined ? formValues.restrictions.limit_by_catalog : false}
                                onChange={(e: any) => {
                                  const isChecked = e.target.checked;
                                  setFormValues({
                                    ...formValues,
                                    restrictions: {
                                      ...formValues.restrictions,
                                      limit_by_catalog: isChecked,
                                      catalogs: isChecked ? (formValues.restrictions?.catalogs || []) : [],
                                    },
                                  });
                                }}
                              />
                            </div>

                            {formValues.restrictions?.limit_by_catalog && (
                              <div className='input_group'>
                                <AutocompleteField
                                  label="Catálogos"
                                  endpoint="/catalogs/list"
                                  value={formValues.restrictions?.catalogs || []}
                                  onChange={(catalogIds: any) => {
                                    console.log("catalogs IDs", catalogIds);
                                    setFormValues({
                                      ...formValues,
                                      restrictions: {
                                        ...formValues.restrictions,
                                        catalogs: catalogIds || []
                                      }
                                    });
                                  }}
                                  multiple={true}
                                />
                              </div>
                            )}


                          <div className='input_group'>
                            <h2>Estado</h2>
                            <ISwitch
                              label="Activo"
                              checked={formValues.is_active}
                              name="is_active"
                              onChange={(e: any) => {
                                setFormValues({
                                  ...formValues,
                                  ["is_active"]: e.target.checked
                                });
                              }}
                            />
                          </div>


                        </div>


                      
                    </div>


                    

                </div>
              </div>
          </div>

          <div className="dialogButtons">
            <Button
                onClick={() => setOpenEditor(false)}
                variant="outlined"
                className="button_2"
            >
              Cancelar
            </Button>

            <Button onClick={() => handleSubmit()} variant="contained" className="button_1">Guardar</Button>
          </div>

        </Dialog>

        {/* Diálogo de confirmación: usuario existe en otra empresa */}
        <Dialog open={emailCheckDialog.open} onClose={() => setEmailCheckDialog({open: false, userName: '', companies: []})}>
          <DialogTitle>Usuario existente</DialogTitle>
          <DialogContent>
            <DialogContentText>
              El usuario <strong>{emailCheckDialog.userName}</strong> ya existe en: <strong>{emailCheckDialog.companies.join(', ')}</strong>. ¿Desea agregarlo a esta empresa?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setEmailCheckDialog({open: false, userName: '', companies: []})}>Cancelar</Button>
            <Button variant="contained" onClick={() => { setEmailCheckDialog({open: false, userName: '', companies: []}); handleSubmit(true); }}>Agregar</Button>
          </DialogActions>
        </Dialog>
      </>
  );
}
